module.exports = __webpack_public_path__ + "static/media/IAMK_posters.a1b45a73.png";